(function () {
  function refreshDrawerFromHTML(html) {
    if (!html) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshDrawer = doc.querySelector('cart-drawer');
      var liveDrawer = document.querySelector('cart-drawer');
      if (freshDrawer && liveDrawer) {
        liveDrawer.innerHTML = freshDrawer.innerHTML;
      }
    } catch (e) {}
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : (request && request.url) || '';
    var promise = originalFetch.apply(this, arguments);
    var isCartEndpoint =
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1;

    if (isCartEndpoint) {
      promise
        .then(function (response) {
          if (!response || !response.ok) return;
          response
            .clone()
            .json()
            .then(function (data) {
              if (data && data.sections && data.sections['cart-drawer']) {
                refreshDrawerFromHTML(data.sections['cart-drawer']);
              }
              if (url.indexOf('/cart/add') !== -1) {
                setTimeout(openDrawer, 100);
              }
            })
            .catch(function () {});
        })
        .catch(function () {});
    }
    return promise;
  };
})();
